import { createFeatureSelector, createSelector } from "@ngrx/store";
import { TrackingsState, trackingFeatureKey } from "./tracking.reducers";
import * as fromReducer from "./tracking.reducers";
import { LocationTrackingDto } from "../interfaces/location_tracking";

const selectFeature = createFeatureSelector<LocationTrackingDto>(
    trackingFeatureKey,
);

export const {
    selectAll: selectAllTrackings,
    selectEntities: selectTrackingEntities,
} = fromReducer.adapter.getSelectors(selectFeature as any);


export const selectTrackingById = (id: string) => (state: any) => {
    return selectTrackingEntities(state)[id];
}

export const selectTrackingByAppointmentId = (appointmentId: number) => createSelector(
    selectAllTrackings,
    (trackings) => {
    return trackings.filter(tracking => tracking.appointment_id === appointmentId)
    .sort((a, b) => b.timestamp - a.timestamp);;
    }
)

export const selectHasTrackingsByAppointmentId = (appointmentId: number) => createSelector(
    selectAllTrackings,
    (trackings) => {
        return trackings.filter(tracking => tracking.appointment_id === appointmentId).length > 0;
    }
)

export const selectIsLoaded = (state: any) => {
    return state[trackingFeatureKey].isLoaded;
}

export const selectIsTracking = (state: any) => {
    return state[trackingFeatureKey].isTracking;
}

export const selectCurrentAppointmentId = (state: any) => {
    return state[trackingFeatureKey].currentAppointmentId;
}
